// src/guide/guide_tour_actions.js
import Shepherd from "shepherd.js";
import "@/guide/shepherd.css";

export function guide_tour_init() {
  const tour = new Shepherd.Tour({
    useModalOverlay: true,
    defaultStepOptions: {
      cancelIcon: { enabled: true },
      scrollTo: { behavior: "smooth", block: "center" },
      modalOverlayOpeningPadding: 6,
      modalOverlayOpeningRadius: 8,
    },
  });

  return tour;
}

export function guide_tour_step_start(
  tour,
  translations,
  title,
  text,
  element,
  position
) {
  tour.addStep({
    title: title,
    text: text,
    attachTo: { element: element, on: position },
    canClickTarget: false,
    buttons: [
      {
        action() {
          return tour.next();
        },
        text: translations.boutons.suivant,
      },
    ],
  });
}

export function guide_tour_step(
  tour,
  translations,
  title,
  text,
  element,
  position,
  btnClick
) {
  tour.addStep({
    title: title,
    text: text,
    attachTo: { element: element, on: position },
    canClickTarget: false,
    buttons: [
      {
        action() {
          tour.cancel();
          return tour.start();
        },
        classes: "shepherd-button-reset",
        text: translations.boutons.recommencer,
      },
      {
        action() {
          if (btnClick) {
            document.getElementById(btnClick).click();
            setTimeout(() => {
              tour.back();
            }, 20);
          } else {
            return tour.back();
          }
        },
        text: translations.boutons.precedent,
      },
      {
        action() {
          return tour.next();
        },
        text: translations.boutons.suivant,
      },
    ],
  });
}

export function guide_tour_step_click_button(
  tour,
  translations,
  title,
  text,
  element,
  position,
  btn,
  btnClick
) {
  tour.addStep({
    title: title,
    text: text,
    attachTo: { element: element, on: position },
    canClickTarget: false,
    buttons: [
      {
        action() {
          tour.cancel();
          return tour.start();
        },
        classes: "shepherd-button-reset",
        text: translations.boutons.recommencer,
      },
      {
        action() {
          if (btnClick) {
            document.getElementById(btnClick).click();
            setTimeout(() => {
              tour.back();
            }, 20);
          } else {
            return tour.back();
          }
        },
        text: translations.boutons.precedent,
      },
      {
        action() {
          document.getElementById(btn).click();
          setTimeout(() => {
            tour.next();
          }, 20);
        },
        text: translations.boutons.suivant,
      },
    ],
  });
}

export function guide_tour_step_complete(
  tour,
  translations,
  title,
  text,
  element,
  position,
  btnClick
) {
  tour.addStep({
    title: title,
    text: text,
    attachTo: { element: element, on: position },
    canClickTarget: false,
    buttons: [
      {
        action() {
          tour.cancel();
          return tour.start();
        },
        classes: "shepherd-button-reset",
        text: translations.boutons.recommencer,
      },
      {
        action() {
          if (btnClick) {
            document.getElementById(btnClick).click();
            setTimeout(() => {
              tour.back();
            }, 20);
          } else {
            return tour.back();
          }
        },
        text: translations.boutons.precedent,
      },
      {
        action() {
          return tour.complete();
        },
        text: translations.boutons.terminer,
      },
    ],
  });
}
